import React from 'react'
import DSSchemaTest from '../components/test/DSSchemaTest'

const DSSchemaTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <DSSchemaTest />
    </div>
  )
}

export default DSSchemaTestPage